import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 6h11","key":"svg-0"}],["path",{"d":"M12 12h8","key":"svg-1"}],["path",{"d":"M15 18h5","key":"svg-2"}],["path",{"d":"M5 6v.01","key":"svg-3"}],["path",{"d":"M8 12v.01","key":"svg-4"}],["path",{"d":"M11 18v.01","key":"svg-5"}]]

const IconListTree = createReactComponent('outline', 'list-tree', 'ListTree', __iconNode);

export default IconListTree;